import React, { useEffect, useState } from 'react';
// import { Container, Typography, FormControl, InputLabel, Input, Box, FormGroup, Button } from '@material-ui/core';
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {addUserService, getPmsUserList, checkUsernameService, getAreaDrClinicList, serviceGetClinic, getProgramData} from  "../Services/Service";
import './Home.css';
import MultiSelectDropdowns from './components/MultiSelectDropdowns';

const initialValue = {
    userName:"",
    firstName: "",
    email : "",
    mobile: "",
    password: "",
    selectedrole: "",
    selectedStatus : "",
    lastName: "",
    btnValue: "",
    action:"",
    updateId:"",
    areaSelect:[],
    clinicSelect:[],
    checkProgramId: []
}

const UserAdd = () => {

    const [user, setUser] = useState(initialValue);
    const {userName,firstName, email, mobile, password,selectedrole,selectedStatus,lastName,btnValue,action,updateId,areaSelect,clinicSelect,checkProgramId } = user;

    const [isvalid, setIsvalid] = useState(true);
    
    const [formErrors, setFormErrors] = useState('');
    const [areaData, setAreaData] = useState([]);
    const [clinicData, setClinicData] = useState([]);
    const [headTitle, setHeadTitle] = useState([]);
    const [programData, setProgramData] = useState([]);
    const [checked, setChecked] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({});
    const [resetMultiSelect, setResetMultiSelect] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    
    const [alertInfo, setAlertInfo] = useState({
        visible : false,
        cls : '',
        msg :''
      });
    const onShowAlert = (msg,visible,clas)=>{
        setAlertInfo({...alertInfo, ['visible']: visible,['cls']:clas,['msg']: msg});
    }

    useEffect(() => {
        fetchAreaClinicDr();
        fetchProgramList();
        if(id != '' && id !== undefined){
            setHeadTitle('Update User');
            loadUserData();
        }else{
            setHeadTitle('Add User');
             setUser({...user, ['btnValue']: 'Submit',['action']: 'add'});
        }
        
    },[]);

    const fetchProgramList = async () => {
        await getProgramData()
            .then((res) => {
                setProgramData(res.data.data)
            }
        );
    }


    const fetchAreaClinicDr = async () => {
        await getAreaDrClinicList()
            .then((res) => {
                setAreaData(res.data.data.area);
                setClinicData(res.data.data.clinic);
    });
    }

    const dropRole = [
        { value: '', label: 'Select' },
        { value: 'admin', label: 'Admin' },
        { value: 'superadmin', label: 'Super Admin' },
        { value: 'operator', label: 'Operator' },
    ];
    const dropStatus = [
        { value: '', label: 'Select' },
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const loadUserData = async () => {
        const response = await getPmsUserList(1,1,'',id);
        const userData = response.data.data[0];

        // Parse areaId and clinicId strings to arrays
        const parsedAreaIds = JSON.parse(userData.areaId || []);
        const parsedClinicIds = JSON.parse(userData.clinicId || []);

        loadAreaClinicData(parsedAreaIds); // optional if you want to filter clinics by areas

        setUser({
            ...user,
            btnValue: 'Update',
            action: 'update',
            updateId: id,
            firstName: userData.firstName,
            lastName: userData.lastName,
            mobile: userData.mobile,
            email: userData.email,
            selectedStatus: userData.status,
            selectedrole: userData.role,
            userName: userData.userName,
            areaSelect: parsedAreaIds,
            clinicSelect: parsedClinicIds,
            checkProgramId: (userData.checkProgramID || []).map(Number)
        });

        // Also update MultiSelectDropdown state directly if needed
        setChecked((userData.checkProgramID || []).map(Number));
    };

    const onValueChange = (e) =>
    {
        if(e.target.name == "mobile"){
            e.target.value =  e.target.value.replace(/\D/g, "");
        }

        if(e.target.id=='userName' && action=='add'){
            console.log('HERE');
            if(e.target.value.length > 3){
                checkUsernameService(e.target.value)
                .then((response) => {
                    if(typeof(response)!=='undefined'){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        if(response.data.status != "1"){
                            setIsvalid(false);
                        }else{
                            setIsvalid(true);
                        }
                        onShowAlert(response.data.data.message,true,clas);
                    }
                });
            }
        }

        if(e.target.id=='areaSelect'){
            loadAreaClinicData(e.target.value);
        }

        setUser({...user, [e.target.name]: e.target.value});
    }

    const handleCheck = (event) => {
        const value = Number(event.target.value);

        let updatedList;
        if (event.target.checked) {
            updatedList = [...checked, value];
        } else {
            updatedList = checked.filter(id => id !== value);
            document.querySelector("#select_all_check").checked = false;
        }

        setChecked(updatedList);
        setUser({ ...user, checkProgramId: updatedList });
    };

    const handleSelectAll = (event) => {
        let updatedList = [];

        if (event.target.checked) {
            updatedList = programData.map(item => Number(item.programId));
        }

        setChecked(updatedList);
        setUser({ ...user, checkProgramId: updatedList });
    };

    const loadAreaClinicData = async (areaId) =>{
        const response = await serviceGetClinic(areaId);
        setClinicData(response.data.data.clinic);
    }
    
    function validateForm(){
        
        // if(mobile.length!=10){
        //     setFormErrors('please Enter 10 digit Mobile No.');
        //     // isvalid = false;
        //     setIsvalid(false);
        // } 
        if(userName.length<=3){
            setFormErrors('please Enter minimum 4 character.');
            setIsvalid(false);
        }  
        if(isvalid){
            setIsvalid(true);
            setFormErrors('');
        }   
        return isvalid;   
    }
    const submitHandle = e => {

        
        e.preventDefault();
        
        let isvalidForm = validateForm();
        if(isvalidForm && isvalid){
            addUserService(user)
                .then((response) => {
                    
                    if (typeof response === 'undefined') return;

                    /* BACKEND VALIDATION*/
                    if (response.data.code === 422) {
                        setFieldErrors(response.data.data.errors || {});
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        return;
                    }

                    /* CLEAR ERRORS ON SUCCESS */
                    setFieldErrors({});

                    if(typeof(response)!=='undefined'){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        if(response.data.status == "1" && user.action=='add'){
                            setUser({...user, ['firstName']: '',['lastName']: '',['mobile']:'',['email']: '',['selectedStatus']: '',['selectedrole']: '',['areaSelect']:[],['clinicSelect']:[],['userName']:'',['checkProgramId']:''});
                            setResetMultiSelect(true);
                        }
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                          });
                        onShowAlert(response.data.data.message,true,clas);    
                    }
                })
        }else{
            console.log('isvalid false');
        }      
    }

    // console.log("areaData" ,areaData);
    // console.log("clinicData" ,clinicData);
    

    return (
        <>
            <section className='projects-section'>
            <div className='row'>
                <h1 className='title mb-4'>{headTitle}</h1>
                {alertInfo.visible ? <div className={"alert alert-"+ alertInfo.cls +" col-md-4 mb-2"} role="alert">{alertInfo.msg}</div> : null}

                {formErrors!='' ? <div className={"alert alert-danger col-md-4"} role="alert">{formErrors}</div> : null}
                

                <form onSubmit={submitHandle} className=''>
                {user.action=='add' ? 
                    <div className="col-md-6">
                    <br/>
                        <div className="form-floating mb-3">
                            <input type="text" id="userName" className="form-control" required name="userName" value={userName} onChange={(e) => onValueChange(e)} />
                            <label className="form-label">User Name</label>
                        </div>
                    </div>
                : null}
                
                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example1" className="form-control" required name="firstName" value={firstName} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">First Name</label>
                    </div>
                </div>

                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example2" className="form-control" required name="lastName" value={lastName} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Last Name</label>
                    </div>
                </div>
                {/* <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example3" className="form-control" required name="mobile" maxLength="10" value={mobile} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Mobile</label>
                    </div>
                </div> */}
                {user.action=='add' ? 
                <>
                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3" >
                        <input type="email" id="form2Example4" className="form-control" required name="email" value={email} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Email address</label>
                    </div>
                </div>
                </>
                : null}
                <div style={{display:"flex",justifyContent:"space-between"}} className="clearfix col-md-6">
                    <div style={{width:"50%"}}>Program List</div>
                    <div style={{width:"50%",display:"flex",justifyContent:"flex-end"}}>
                    <input onClick={(e)=>{handleSelectAll(e)}} type="checkbox" id="select_all_check" />
                    <label htmlFor="select_all_check" className="form-check-label" style={{marginLeft: "5px"}}>Select All</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating mb-3 form-check">
                    {programData?.map((item, index) => (
                        <div key={index} className="multiCheckbox">
                            <input
                            className="form-check-input"
                            style={{ fontStyle: "normal" }}
                            type="checkbox"
                            id={item.programId}
                            value={item.programId}
                            // checked={item.isAdded}
                            
                            // checked={checkProgramId.length>0 ? (checkProgramId.find((programId) => (programId.includes(item.programId) ) ? true:false) ) : null}
                            checked={checkProgramId.includes(Number(item.programId))}
                            onChange={handleCheck}
                            />
                        <label className="form-check-label" htmlFor={item.programId}>
                        {item.programName}
                        </label>
                        </div>
                        ))}
                        
                    </div>
                </div>
                {/* <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="password" id="form2Example5" className="form-control" required autoComplete="off" name="password" value={password} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Password</label>
                    </div>
                </div>   */}
                {/* <div className="clearfix"></div> 
                <div className="col-md-6">
                    <div  className="form-floating mb-3"> 
                        <select id="areaSelect" name="areaSelect" className='form-control' value={areaSelect} onChange={onValueChange} >
                            <option value="">-- SELECT AREA --</option>
                            {areaData.map((data, i) => (
                                // <option key={i} value={data.areaId}>{data.areaName}</option>
                                <option value={data.areaId}  key={i}>{data.areaName}</option>
                            ))}
                        </select>

                        <label className="form-label">Select Area</label>
                    </div>
                </div> 

                <div className="clearfix"></div> 
                <div className="col-md-6">
                    <div  className="form-floating mb-3">  
                    <select id="clinicSelect" name="clinicSelect" value={clinicSelect} className='form-control' required  onChange={onValueChange} >
                        <option value="">-- SELECT CLINIC --</option>
                        {clinicData.map((data, i) => (
                            // <option key={i} value={data.clinicId}>{data.name}</option>
                            <option value={data.clinicId} key={i}>{data.name}</option>
                        ))}
                    </select>
                        <label className="form-label">Select Clinic</label>
                    </div>
                </div>  */}

<MultiSelectDropdowns 
  areaData={areaData}
  clinicData={clinicData}
  onChange={onValueChange}
  errors={fieldErrors}
  resetSelections={resetMultiSelect}
  selectedAreas={areaSelect}
  selectedClinics={clinicSelect}
/>

                <div className="clearfix"></div> 
                <div className="col-md-6">
                    <div  className="form-floating mb-3">  
                        <select className="form-control" required
                            value={selectedrole} name="selectedrole" 
                            onChange={(e) => onValueChange(e)} >
                            {dropRole.map((dropRole,i) => (
                                <option value={dropRole.value} key={i}>{dropRole.label}</option>
                            ))}
                        </select>
                        <label className="form-label">Select Role</label>
                    </div>
                </div> 

                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <select className="form-control" required
                            value={selectedStatus} name="selectedStatus"
                            onChange={(e) => onValueChange(e)} >
                            {dropStatus.map((dropStatus,i) => (
                                <option value={dropStatus.value}  key={i}>{dropStatus.label}</option>
                            ))}
                        </select>
                        <label className="form-label">Status</label>
                    </div>
                </div>
                
                <div className="clearfix"></div>
                <div className="col-md-6 mt-3">
                    <button type="submit" className="btn btn-primary btn-login mb-4" name="btnValue">{user.btnValue}</button>
                </div>
                    
                </form>
                </div>

</section>

        </>
    )
}


export default UserAdd;